export default __webpack_public_path__ + "static/media/wjwx5vF0xB.2e045d0f.jpeg";